export default __webpack_public_path__ + "static/media/pptx.df54630b.svg";